/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateGoogleMerchantMarketReportSettingsRequest
 */
export interface UpdateGoogleMerchantMarketReportSettingsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateGoogleMerchantMarketReportSettingsRequest
     */
    countryCodes: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateGoogleMerchantMarketReportSettingsRequest
     */
    categoryIds: Array<string>;
    /**
     * 
     * @type {UpdateGoogleMerchantMarketReportSettingsRequestGranularityEnum}
     * @memberof UpdateGoogleMerchantMarketReportSettingsRequest
     */
    granularity: UpdateGoogleMerchantMarketReportSettingsRequestGranularityEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateGoogleMerchantMarketReportSettingsRequest
     */
    competitiveWindowDays: number;
}


/**
 * @export
 */
export const UpdateGoogleMerchantMarketReportSettingsRequestGranularityEnum = {
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY'
} as const;
export type UpdateGoogleMerchantMarketReportSettingsRequestGranularityEnum = typeof UpdateGoogleMerchantMarketReportSettingsRequestGranularityEnum[keyof typeof UpdateGoogleMerchantMarketReportSettingsRequestGranularityEnum];


/**
 * Check if a given object implements the UpdateGoogleMerchantMarketReportSettingsRequest interface.
 */
export function instanceOfUpdateGoogleMerchantMarketReportSettingsRequest(value: object): value is UpdateGoogleMerchantMarketReportSettingsRequest {
    if (!('countryCodes' in value) || value['countryCodes'] === undefined) return false;
    if (!('categoryIds' in value) || value['categoryIds'] === undefined) return false;
    if (!('granularity' in value) || value['granularity'] === undefined) return false;
    if (!('competitiveWindowDays' in value) || value['competitiveWindowDays'] === undefined) return false;
    return true;
}

export function UpdateGoogleMerchantMarketReportSettingsRequestFromJSON(json: any): UpdateGoogleMerchantMarketReportSettingsRequest {
    return UpdateGoogleMerchantMarketReportSettingsRequestFromJSONTyped(json, false);
}

export function UpdateGoogleMerchantMarketReportSettingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateGoogleMerchantMarketReportSettingsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'countryCodes': json['countryCodes'],
        'categoryIds': json['categoryIds'],
        'granularity': json['granularity'],
        'competitiveWindowDays': json['competitiveWindowDays'],
    };
}

export function UpdateGoogleMerchantMarketReportSettingsRequestToJSON(json: any): UpdateGoogleMerchantMarketReportSettingsRequest {
    return UpdateGoogleMerchantMarketReportSettingsRequestToJSONTyped(json, false);
}

export function UpdateGoogleMerchantMarketReportSettingsRequestToJSONTyped(value?: UpdateGoogleMerchantMarketReportSettingsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'countryCodes': value['countryCodes'],
        'categoryIds': value['categoryIds'],
        'granularity': value['granularity'],
        'competitiveWindowDays': value['competitiveWindowDays'],
    };
}

